module.exports = __webpack_public_path__ + "b49f83570c0182fd56fee2d0474b258a.png";